import React from 'react';
import './App.css';
import Main from './components/main/main'


function App() {
  return (
    <div >
      <Main />
    </div>
  );
}

export default App;
